const labels = document.querySelectorAll('.label-with-image');

if (labels.length > 0) {
	labels.forEach((label) => {
		label.addEventListener("click", function(event) {
			const dataName = label.dataset.name;
			const select = document.querySelector(`.select__select[name="options[${dataName}]"]`);

			labels.forEach((label) => {
				label.classList.remove('active');
				label.previousElementSibling.removeAttribute("checked");
			});
			const targetElement = event.target || event.srcElement;
			targetElement.classList.add('active');

			const value = targetElement.getAttribute('value');
			select.value = value;

			const nEvent = new Event('change', { bubbles: true });
			select.dispatchEvent(nEvent);
		});     
	});
}